import { render, staticRenderFns } from "./sihuang-contract.html?vue&type=template&id=12df83f8&scoped=true&external"
import script from "./sihuang-contract.js?vue&type=script&lang=js&external"
export * from "./sihuang-contract.js?vue&type=script&lang=js&external"
import style0 from "./sihuang-contract.scss?vue&type=style&index=0&id=12df83f8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df83f8",
  null
  
)

export default component.exports